import classes from "./baErrorBox.scss";
const BaErrorBox = (props) => {
    let warningIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Warning.svg';
    return (
        <div className={"row "+classes.errorContainer}>
            <div className="col-xs-12">
                <img src={warningIcon}  alt="Warning Icon" />
                <p>{props.message}</p>
            </div>
        </div>
    );
};

export default BaErrorBox;